// test2780
(2780 && 0);
